module.exports = __webpack_public_path__ + "fdfe98cf151845e35b0059acca1e77da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title.png
// module id = 174
// module chunks = 0